import createEntityConnect from "../rx/createEntityConnect";
import createEntityLayout from "./createEntityLayout";
export default function createEntityScreen(args) {
    return createEntityConnect({
        entityName: args.entityName,
        columnHeaders: args.columnHeaders,
        columnConfiguration: args.columnConfiguration
    })(createEntityLayout(args));
}
